import React, { useState, useEffect } from "react";
import firebase from "../firebase";
import Exsist from "./Exsist";
import AddUser from "./AddUser";
import Header from "./Header";
import Loader from "react-spinners/ClipLoader";

const Home = (props) => {
  const [loading, setLoading] = useState(true);
  const [check, setCheck] = useState(true);
  const [user, setUser] = useState(false);
  useEffect(() => {
    firebase
      .firestore()
      .collection(`user`)
      .doc(`${props.sec.sec}`)
      .get()
      .then((doc) => {
        if (doc.exists) {
          setCheck(true);
          
          setUser(doc.data());
        } else {
          setCheck(false);
        }
        setLoading(false);
      });
  }, []);
  
  return (
    <div>
      {loading ? (<div style={{textAlign: "center"}}>
      <h1>Loading</h1>
    <Loader loading={loading} color={`#4285f4`}  size={150} /> </div>) : (
        <div>
          <Header setSec={props.setSec} />
        {check ? (
          <Exsist user={user} setSec={props.setSec} />
        ) : (
          <AddUser sec={props.sec} setCheck={setCheck} />
        )}
        </div>
      )}
    </div>
  );
};

export default Home;
